export default __webpack_public_path__ + "static/media/no_result.b403cb75.png";